import React, { useMemo } from 'react'
import {
  BrowserRouter,
  Routes,
  Route,
  Navigate,
  Outlet,
} from 'react-router-dom'
import { PageUnderDevelopment, ScrollToTop } from 'components'
import { ThemeProvider } from 'styled-components'
import { FirebaseService } from 'utility'
import { RoleGuard } from 'guards'
import 'antd/dist/reset.css'
import {
  CompetitionDetailScreen,
  CompetitionsAddEditScreen,
  CompetitionsScreen,
  CreatorsScreen,
  DashBoardScreen,
  FlaggedCommentsScreen,
  NotificationsScreen,
  RoundDetailScreen,
  SettingsScreen,
  SignInScreen,
  VideosScreen,
  ViewersScreen,
} from 'screens'
import { AuthProvider } from 'context'
import { useDarkMode } from 'hooks'
import { darkTheme, lightTheme } from 'theme'
import './App.css'
import { CreatorsDetails } from 'screens/creator/details/details'
import { CompetitionDetail } from 'screens/creator/details/compititonDetails'
import { ViewersDetails } from 'screens/viewers/viewresDetails'
import { WinnerSelectionPage } from 'page-components/competitions/Round/WinnerSelectionPage'

FirebaseService.init()

function App() {
  const [theme] = useDarkMode()
  const themeMode = useMemo(
    () => (theme === 'light' ? lightTheme : darkTheme),
    [theme],
  )
  return (
    <BrowserRouter>
      <AuthProvider>
        <ThemeProvider theme={themeMode}>
          <ScrollToTop />
          <Routes>
            <Route path="/login" element={<SignInScreen />} />
            <Route path="/" element={<Navigate replace to="app" />} />
            {/* Protected routes */}
            <Route
              path="app"
              element={
                <RoleGuard>
                  <Outlet />
                </RoleGuard>
              }
            >
              <Route path="" element={<Navigate to="dashboard" />} />
              <Route path="dashboard" element={<DashBoardScreen />} />
              <Route path="competitions" element={<Outlet />}>
                <Route path="" element={<CompetitionsScreen />} />
                <Route path="select-winners/:competitionId/:round" element={<WinnerSelectionPage />} />
                <Route path=":competitionId/rounds/:round" element={<RoundDetailScreen />} />
                <Route path=":id" element={<CompetitionDetailScreen />} />
                <Route path="add-edit" element={<Outlet />}>
                  <Route path="" element={<CompetitionsAddEditScreen />} />
                  <Route path=":id" element={<CompetitionsAddEditScreen />} />
                </Route>
              </Route>
              <Route path="manage-creators" element={<CreatorsScreen />} />
              <Route
                path="manage-creators/creators-detail/:id"
                element={<CreatorsDetails />}
              />
              <Route
                path="manage-creators/compititon-detail/:id"
                element={<CompetitionDetail />}
              />

              <Route path="manage-viewers" element={<ViewersScreen />} />
              <Route
                path="manage-viewers/viewers-detail/:id"
                element={<ViewersDetails />}
              />
              <Route path="settings" element={<SettingsScreen />} />
              <Route path="videos" element={<VideosScreen />} />
              <Route path="notifications" element={<NotificationsScreen />} />
              <Route
                path="flagged-comments"
                element={<FlaggedCommentsScreen />}
              />
              <Route path="*" element={<PageUnderDevelopment />} />
            </Route>
          </Routes>
        </ThemeProvider>
      </AuthProvider>
    </BrowserRouter>
  )
}

export default App
